@use 'variables' as *;
@use 'mixins' as *;
@use 'base';
@use 'objects';
@use 'components';
@use 'layout';
@use 'modules';
@use 'helpers';
@use 'atomizer';

// Color variables specific only to this file
$color-anim-vwo-loader-color-1: $color-gray-5;
$color-anim-vwo-loader-color-2: $color-gray-5;
$color-anim-vwo-loader-color-3: $color-gray-5;

// New vwo loader
.vwo-loader-wrap {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	padding-left: calc(100vw - 100%); /* Negating the scrollbar width from left side */
	z-index: $z-index-15; // above shell topbar, shell sidebar, and settings page sidebar
	background: $color-gray-05; // to hide everything behind it
	display: flex;
	align-items: center;
	justify-content: center;
}

.vwo-loader {
	text-align: center;
	position: relative;
}

.vwo-loader__logo {
	img {
		display: block;
		margin-inline: auto;
		width: $spacing-17 + 2;
		height: $spacing-17 + 2;
		max-width: $spacing-17 + 2;
		max-height: $spacing-17 + 2;
	}
}

.vwo-loader__text {
	margin-top: $spacing-5;
	font-size: $small-size;
	line-height: $small-line-height;
	color: $color-gray-7;
	position: relative;
	-moz-osx-font-smoothing: grayscale; // Prevent light fonts appear blurry due to OSX sub-pixel anti aliasing
}

.vwo-loader__dots {
	display: inline-block;
	width: 1.25em;
	overflow: hidden;
	vertical-align: bottom;
	white-space: nowrap;
	text-align: start;

	&::after {
		content: '...';
		display: inline-block;
		overflow: hidden;
		white-space: nowrap;
		vertical-align: bottom;
		width: 0;
		animation: vwo-loader-ellipsis 1.4s steps(4, end) infinite;
	}
}

@keyframes vwo-loader-ellipsis {
	to {
		width: 1.25em;
	}
}

@media (prefers-reduced-motion: reduce) {
	.vwo-loader__dots::after {
		animation: none;
		width: 1.25em;
	}
}

.vwo-loader__circular {
	width: 120px;
	height: 120px;
	border-radius: 50%;
	border: $color-gray-3 1px solid;
	position: relative;
	left: calc(50% - $spacing-15);
	animation: anim-vwo-loader-rotate 1.5s infinite linear, anim-vwo-loader-color 3s infinite;
	z-index: -$z-index-1;

	&::after {
		content: '';
		width: $spacing-5;
		height: $spacing-12 + 2; // 50px
		background: $color-gray-05;
		position: absolute;
		top: calc(100% - 25px);
		left: calc(50% - 10px);
		animation: anim-vwo-loader-scale 2s infinite linear;
	}
}

@keyframes anim-vwo-loader-rotate {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

@keyframes anim-vwo-loader-scale {
	0% {
		transform: scale(1);
	}
	50% {
		transform: scaleX(10);
	}
	100% {
		transform: scale(1);
	}
}

@keyframes anim-vwo-loader-color {
	100%,
	0% {
		border-color: $color-gray-3;
	}
	40% {
		border-color: $color-anim-vwo-loader-color-1;
	}
	60% {
		border-color: $color-anim-vwo-loader-color-2;
	}
	80% {
		border-color: $color-anim-vwo-loader-color-3;
	}
}

@keyframes rotate {
	to {
		transform: rotate(360deg);
	}
}

.loader {
	display: inline-block;
	width: $spacing-3;
	height: $spacing-3;
	color: inherit;
	border: $spacing-05 solid;
	border-bottom-color: transparent;
	border-radius: 50%;
	background: transparent;
	animation: 600ms rotate linear infinite;
}

[ng\:cloak],
[ng-cloak],
[data-ng-cloak],
[x-ng-cloak],
.ng-cloak,
.x-ng-cloak {
	display: none !important;
}

.ng-hide-remove {
	display: none !important;
}

.is-full-mode .navbar,
.is-full-mode .header-main,
.modal-box {
	visibility: hidden;
}

// Set minimum height of main view to the current window height
[ui-view='main-setup'],
[ui-view='main'] {
	display: none;
}
.login-successful {
	[ui-view='main-setup'],
	[ui-view='main'] {
		min-height: calc(100vh - #{$header-height + $page-header-height}); // 40px = height of .header-main
		display: block;
		.top-banner & {
			min-height: calc(100vh - (#{$header-height + $spacing-7 + $page-header-height}));
		}
		.shell-nav-enabled & {
			min-height: calc(100vh - #{$spacing-14 + $spacing-20});
		}
		.shell-nav-enabled.top-banner & {
			// Extra $spacing-7 matches the 28px top padding on #main-container when the banner and shell nav are both on.
			min-height: calc(100vh - (#{$spacing-14 + $spacing-20}));
		}
	}
}

.dropdown__menu,
.hidden,
.notifications-container {
	display: none;
}

.icon {
	background-repeat: no-repeat;
	display: inline-block;
}

.btn-group {
	display: inline-block;
	position: relative;
	vertical-align: middle;
}

.btn-group > .btn:first-child:not(:last-child):not([vwo-dropdown-toggle]),
.btn-group > .select:first-child:not(:last-child):not([vwo-dropdown-toggle]) > .btn {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	// border-right: 0;
}

.btn-group > .btn:last-child:not(:first-child),
.btn-group > .btn:last-child:not(:first-child) > .btn {
	border-left: 0;
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}

.btn-group > .btn,
.btn-group > .btn-group,
.btn-group > .select {
	float: left;
}

.btn {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	cursor: default;
	white-space: nowrap;
	font-family: inherit;
	margin: 0;
	text-decoration: none;
	padding: 0 10px;
	border: 1px solid $color-gray-5;
	border-radius: $spacing-05;
	@include font-weight-normal;

	&:not(.no-hover) {
		cursor: pointer;
	}
}

.btn--small,
.select--small > .btn {
	font-size: $small-size;
	line-height: $small-line-height;
	padding: 0 10px;
	height: $spacing-6;
}

.btn--negative {
	background: transparent;
	color: $color-red-5;
	border-color: $color-red-5;
}

.main-wrap {
	margin-left: $navbar-width;
}
